import React, { JSX, FC } from "react";
import { ReactComponent as HelpOutlinedIcon } from "assets/icons/help_outlined_icon.svg";

interface IHintProps {
  text: string;
  handleClick: () => void;
}

const Hint: FC<IHintProps> = ({ text, handleClick }): JSX.Element => {
  return (
    <p className="flex items-center cursor-pointer blue-color" onClick={handleClick}>
      {text}
      <HelpOutlinedIcon />
    </p>
  );
};

export default Hint;
